import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EmployeeAuthLoginForm } from '@/components/features/auth/EmployeeAuthLoginForm'
import { PageWithHeader, PageWrapper } from '@/components/layout'
import { ErrorMessageList } from '@/components/ui'
import { ROUTE } from '@/const'

export const EmployeeLoginPage = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const [errorMessages, setErrorMessages] = useState<string[]>([])

  const handleSuccessLogin = () => {
    router.push(ROUTE.selectStore)
  }

  return (
    <PageWithHeader
      withSearch={false}
      withMenu={false}
      withLinks={false}
      disableLogoLink={true}
    >
      <PageWrapper withBreadcrumb={false} spacingX={'sm'} pcWidth={'half'}>
        {errorMessages.length > 0 && (
          <div className={clsx('tw-mb-6 tw-text-center')}>
            <ErrorMessageList errorMessages={errorMessages} />
          </div>
        )}
        <h1 className={clsx('tw-text-center tw-text-lg tw-font-bold')}>
          {t('login.employeeTitle')}
        </h1>
        <div className={clsx('tw-mt-6')}>
          <EmployeeAuthLoginForm
            onSuccess={handleSuccessLogin}
            onChangeErrorMessage={setErrorMessages}
          />
        </div>
        <div
          className={clsx(
            'tw-mt-6 tw-flex tw-flex-col tw-items-center tw-gap-2'
          )}
        >
          <div className={clsx('tw-text-sm tw-text-gray-600')}>
            {t('auth.employeeLogin.forgotPassword.prefix')}
            <Link
              href={ROUTE.contactForm('password')}
              className={clsx(
                'tw-text-primary-500 tw-underline hover:tw-opacity-60'
              )}
            >
              {t('auth.employeeLogin.forgotPassword.linkText')}
            </Link>
            {t('auth.employeeLogin.forgotPassword.suffix')}
          </div>
        </div>
      </PageWrapper>
    </PageWithHeader>
  )
}
